module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('svg', {
    attrs: {
      "width": "20",
      "height": "20",
      "viewBox": "0 0 20 20",
      "fill": "none",
      "xmlns": "http://www.w3.org/2000/svg"
    }
  }, [_c('circle', {
    attrs: {
      "opacity": "0.2",
      "cx": "10",
      "cy": "10",
      "r": "9.5",
      "fill": "#9BA1AB"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "fill-rule": "evenodd",
      "clip-rule": "evenodd",
      "d": "M6.54795 6.54775C6.30306 6.79264 6.30306 7.1897 6.54796 7.43459L9.20907 10.0957L6.54795 12.7568C6.30306 13.0017 6.30306 13.3988 6.54795 13.6437C6.79285 13.8886 7.1899 13.8886 7.4348 13.6437L10.0959 10.9825L12.7558 13.6425C13.0007 13.8874 13.3978 13.8874 13.6427 13.6425C13.8876 13.3976 13.8876 13.0005 13.6427 12.7556L10.9827 10.0957L13.6427 7.43577C13.8876 7.19088 13.8876 6.79382 13.6427 6.54893C13.3978 6.30404 13.0007 6.30404 12.7558 6.54893L10.0959 9.20886L7.4348 6.54775C7.1899 6.30285 6.79285 6.30285 6.54795 6.54775Z",
      "fill": "#9BA1AB"
    }
  })])
},staticRenderFns: []}
module.exports.render._withStripped = true
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-225c8a76", module.exports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-225c8a76","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/registration/multiplePhonePlan/icons/CloseIcon.vue
// module id = 851
// module chunks = 0